import { ActionReducer, INIT } from '@ngrx/store';

import { AppActions } from '../app/app.actions';
import { AppState } from '../app/app.state';
import { HomeState } from '../home/home.state';
import { RootState } from '../root-state.model';
import { RootStoreActions } from '../root-store.actions';

export function changeAssetFactory() {
  return (reducer: ActionReducer<RootState>): ActionReducer<RootState> => {
    return (state, action) => {
      if (action?.type === RootStoreActions.ChangeAsset.type) {
        return reducer(
          {
            app: {
              ...state.app,
              initialized: false,
            } as AppState,
            home: {} as HomeState,
            userProfile: state.userProfile,
          } as any,
          { type: INIT },
        );
      }

      // Same reset, but carrying this tab's newly chosen scope through it — the wipe replays INIT
      // instead of the action, so a reducer case for `UseWorkspace` would never run.
      if (action?.type === AppActions.UseWorkspace.type) {
        const { workspaceId, assetShortNames } = action as ReturnType<typeof AppActions.UseWorkspace>;

        return reducer(
          {
            app: {
              ...state.app,
              initialized: false,
              selectedWorkspaceId: workspaceId,
              selectedAssetShortNames: assetShortNames,
            } as AppState,
            home: {} as HomeState,
            userProfile: state.userProfile,
          } as any,
          { type: INIT },
        );
      }

      return reducer(state, action);
    };
  };
}
